const utf8 = new TextEncoder();

function primitive(item) {
  if (item === null || typeof item === 'boolean' || typeof item === 'string')
    return JSON.stringify(item);
  if (typeof item !== 'number') return undefined;
  if (!Number.isFinite(item) || (Number.isInteger(item) && !Number.isSafeInteger(item)))
    throw new TypeError('Invalid JSON number');
  return JSON.stringify(item);
}

export function canonicalJson(value, { maxDepth = 16, maxBytes = 262144 } = {}) {
  const active = new Set();
  function encode(item, depth) {
    if (depth > maxDepth) throw new TypeError('JSON depth exceeded');
    const scalar = primitive(item);
    if (scalar !== undefined) return scalar;
    if (typeof item !== 'object' || active.has(item)) throw new TypeError('Invalid JSON value');
    if (!Array.isArray(item) && ![Object.prototype, null].includes(Object.getPrototypeOf(item)))
      throw new TypeError('JSON object required');
    active.add(item);
    const result = Array.isArray(item)
      ? '[' + Array.from(item, (value) => encode(value, depth + 1)).join(',') + ']'
      : '{' +
        Object.keys(item)
          .sort()
          .map((key) => JSON.stringify(key) + ':' + encode(item[key], depth + 1))
          .join(',') +
        '}';
    active.delete(item);
    if (utf8.encode(result).byteLength > maxBytes) throw new TypeError('JSON byte limit exceeded');
    return result;
  }
  const result = encode(value, 0);
  if (utf8.encode(result).byteLength > maxBytes) throw new TypeError('JSON byte limit exceeded');
  return result;
}
